import { render, staticRenderFns } from "./CommunityMemberForm.vue?vue&type=template&id=2161d683&"
import script from "./CommunityMemberForm.vue?vue&type=script&lang=js&"
export * from "./CommunityMemberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports